/* eslint-disable react/prop-types */
import Loading from "components/Loading";
import ModalUI from "components/ModalUI";
import SoftButton from "components/SoftButton";
import React, { useEffect, useState } from 'react'
import { toast } from "react-toastify";
import { updateWithdraw } from "services/withdraw.routes";
import { getSingleWithdraw } from "services/withdraw.routes";
import queryString from "utils/queryString";
import separate from "utils/separate";

export default function WithdrawInfoModal({ modalInfo, setWithdraw, closeModal }) {
    const [loading, setLoading] = useState(false)
    const [singleWithdraw, setSingleWithdraw] = useState()
    useEffect(() => {
        if (modalInfo?.item?.id) {
            setLoading(true);
            getSingleWithdraw(modalInfo?.item?.id, (isOk, data) => {
                setLoading(false);
                if (!isOk) {
                    return toast.error(data.message);
                }
                else {
                    setSingleWithdraw(data)
                }
            })
        }

    }, [modalInfo.item])

    const handleUpdateWithdraw = (isPayed) => {
        let answer = window.confirm(`آیا از ${isPayed ? 'تایید' : " لغو"} اطمینان دارید؟`);
        if (answer) {
            const query = {
                status: isPayed ? 2 : 3
            }
            setLoading(true);
            updateWithdraw(modalInfo?.item?.id, queryString(query), (isOk, data) => {
                setLoading(false);
                if (!isOk) {
                    return toast.error(data.message);
                }
                else {
                    setWithdraw(prev =>
                        prev.map(item =>
                            item.id === modalInfo?.item?.id
                                ? { ...item, status: query.status }
                                : item
                        )
                    );
                    closeModal()
                    toast.success('درخواست ثبت شد')
                }
            })
        }
    }
    return (
        <ModalUI open={modalInfo.state} handleClose={closeModal} style={{ minWidth: "600px" }}>
            <Loading loading={loading} />
            {singleWithdraw && <div style={{ fontSize: 16 }}>
                <p>نام کاربر: {singleWithdraw?.wallet_transaction?.user?.first_name} {singleWithdraw?.wallet_transaction?.user?.last_name}</p>
                <p>شماره شبا: {singleWithdraw?.wallet_transaction?.user?.sheba_number}</p>
                <p>مبلغ برداشت: {separate(Number(singleWithdraw?.wallet_transaction.amount))} تومان</p>
                <p>موجودی: {separate(Number(singleWithdraw?.wallet_transaction.balance))} تومان</p>
                {singleWithdraw.status === 1 && <><SoftButton
                    size="small"
                    onClick={() => handleUpdateWithdraw(true)}
                    style={{ marginTop: 30, marginLeft: 10 }}
                    variant="gradient"
                    color="success"
                >
                    انجام شد
                </SoftButton>
                    <SoftButton
                        size="small"
                        onClick={() => handleUpdateWithdraw(false)}
                        style={{ marginTop: 30 }}
                        variant="gradient"
                        color="error"
                    >
                        لغو
                    </SoftButton>
                </>}
            </div>}
        </ModalUI>
    )
}
